// extracted by mini-css-extract-plugin
export default {"wrapper":"BarChart_wrapper__sjMDi","loading":"BarChart_loading__v1-4O","avg-container":"BarChart_avg-container__1OAr9"};